import React from 'react';
import './Login.css';
import user from '../../assets/user.svg';
import pass from '../../assets/pass.svg';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions/auth';

const Login = (props) => {
  let [username, setUsername] = React.useState('');
  let [password, setPassword] = React.useState('');
  let [isUserNameActive, setUserNameActive] = React.useState(false);
  let [isPasswordActive, setPasswordActive] = React.useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    props.onSubmit(username,password);
  }

  const handleUserNameChange = (value) => {
    setUserNameActive(value !== '' ? true : false);
    setUsername(value);
  }
  const handlePasswordChange = (value) => {
    setPasswordActive(value !== '' ? true : false);
    setPassword(value);
  }
  return (
    <div className="container">
      <div className="logo-brand">
        555Mix
      </div>
      <form onSubmit={handleSubmit} className="form">
        <div className="form-header">
          <h3>Member Login</h3>
        </div>
        <div className="form-body">
          <div className="form-group">
            <img src={user} alt="user-icon" className="icon" />
            <div id="input">
              <label htmlFor="text" className={isUserNameActive ? 'Active' : ''}>Username</label>
              <input
                type="text"
                className="text-field"
                required
                autoComplete="new-password"
                onChange={e => handleUserNameChange(e.target.value)}
                value={username}
              />
            </div>
          </div>
          <div className="form-group">
            <img src={pass} alt="pass-logo" className="icon" />
            <div id="input">
              <label htmlFor="password" className={isPasswordActive ? 'Active' : ''}>Password</label>
              <input
                type="password"
                className="text-field"
                required
                autoComplete="new-password"
                onChange={e => handlePasswordChange(e.target.value)}
                value={password}
              />
            </div>
          </div>
          <div className="form-footer">
            <div className="error-text" style={{display:props.error?'flex':'none'}}>Invalid Member ID or Password</div>
            <input type="submit" className="submit-btn" value="Login"/>
          </div>
        </div>
      </form>
    </div>
  );
};
const mapStateToProps=state=>{
  return {
    token:state.auth.token,
    error:state.auth.error,
  }
}
const mapDispatchToProps=dispatch=>{
  return {
    onSubmit:(username,password)=>dispatch(actions.auth(username,password))
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Login);